import { SESSION_VARIABLES } from '../constants/session'
import {
  SPANISH_LANG_CODE,
  SPANISH_LANG_CODE_SHORT,
  ENGLISH_LANG_CODE
} from '../constants/lang'

export const getSessionValue = (name) =>
  typeof window !== 'undefined' ? window.sessionStorage.getItem(name) : ''

export const isWindow = () => typeof window !== 'undefined'

export const getDomainURL = () => {
  if (isWindow()) {
    return window.location.origin
  }

  return 'false'
}

export const tryJSONParseSessionStorageValue = (name) => {
  try {
    const stringValue = window?.sessionStorage?.getItem?.(name)
    if (typeof stringValue === 'string') {
      return JSON.parse(stringValue)
    }
  } catch (e) {
    return {}
  }
  return {}
}

export const getSessionStorageValue = (name) => {
  if (isWindow()) {
    return typeof sessionStorage !== 'undefined'
      ? window.sessionStorage.getItem(name)
      : null
  }

  return 'true'
}
export const setSessionStorageValue = (name, value) => {
  window.sessionStorage.setItem(name, value)
}

export const onEnv = (env) => {
  if (isWindow()) {
    const domain = getDomainURL()

    return domain.split('.')[0].indexOf(env) !== -1
  }

  return 'true'
}

export const getOLBRoutingKey = () => {
  if (isWindow()) {
    const domain = getDomainURL()
    const domainName = domain.split('.')[0].split('-')[0].split('//')[1]
    if (domainName === 'onlinebanking2') return 'preprod'
    if (domainName.slice(0, -1) === 'it') return 'it4'
    if (domainName.slice(0, -1) === 'uat') return 'uat4'
    if (
      domainName === 'onlinebanking' ||
      domainName === 'emp' ||
      domainName === 'onlinebankingaggregators'
    )
      return ''
    return domainName
  }

  return ''
}

export const getLocale = () => {
  const langCode = getSessionStorageValue('Language')
  return langCode === SPANISH_LANG_CODE_SHORT || langCode === SPANISH_LANG_CODE
    ? SPANISH_LANG_CODE
    : ENGLISH_LANG_CODE
}
export const getRoutingKey = () =>
  getSessionValue(SESSION_VARIABLES.routingKey) !== null
    ? getSessionValue(SESSION_VARIABLES.routingKey)
    : getOLBRoutingKey()
export const isOnProd = () =>
  !onEnv('localhost') && !onEnv('it') && !onEnv('uat') && !onEnv('dev')

export const getParamsFromSessionStorage = () =>
  new Promise((resolve) =>
    resolve({
      AccessToken:
        getSessionValue(SESSION_VARIABLES.AccessToken) !== null
          ? getSessionValue(SESSION_VARIABLES.AccessToken)
          : '',
      correlationID:
        getSessionValue(SESSION_VARIABLES.correlationID) !== null
          ? getSessionValue(SESSION_VARIABLES.correlationID)
          : '',
      routingKey: isOnProd() ? '' : getRoutingKey(),
      Channel:
        getSessionValue(SESSION_VARIABLES.Channel) !== null
          ? getSessionValue(SESSION_VARIABLES.Channel)
          : 'OLB',
      Language:
        getSessionValue(SESSION_VARIABLES.Language) !== null
          ? getSessionValue(SESSION_VARIABLES.Language)
          : '',
      returnURL:
        getSessionValue(SESSION_VARIABLES.returnURL) !== null
          ? getSessionValue(SESSION_VARIABLES.returnURL)
          : `${getDomainURL()}/digital/servicing/customer-dashboard`,
      LogoutURL:
        getSessionValue(SESSION_VARIABLES.LogoutURL) !== null
          ? getSessionValue(SESSION_VARIABLES.LogoutURL)
          : `${getDomainURL()}/Auth/LogoutConfirmation`,
      AFTokenValue:
        getSessionValue(SESSION_VARIABLES.AFTokenValue) !== null
          ? getSessionValue(SESSION_VARIABLES.AFTokenValue)
          : '',
      deviceAppVersion:
        getSessionValue(SESSION_VARIABLES.deviceAppVersion) !== null
          ? getSessionValue(SESSION_VARIABLES.deviceAppVersion)
          : '',
      billpayDeepLink:
        getSessionValue(SESSION_VARIABLES.billpayDeepLink) !== null
          ? getSessionValue(SESSION_VARIABLES.billpayDeepLink)
          : ''
    })
  )
